<template>
  <!-- <main class="main-wrapper"> -->
    <section class="exhibitor-listing__wrapper" id="app">
      <div class="container-row">
        <DropDownFilter />
        <AlphaNumericFilter @viewAll="initPagination" />
        <ExhibitorList />
      </div>
      <div class="alphabet-sort pagination-wrapp">
        <paginate v-if="pageCount > 0" :page-count="pageCount" :force-page="forcePage" :page-range="5" :margin-pages="3"
          :click-handler="clickCallback" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"
          :page-class="'page-item'" ref="pagination" />
      </div>
    </section>
  <!-- </main> -->
</template>

<script>
import ExhibitorList from "./ExhibitorList/ExhibitorListing";
import DropDownFilter from "./ExhibitorList/DropDownFilter";
import AlphaNumericFilter from "./ExhibitorList/AlphaNumericFilter.vue";
//const DropDownFilter = () => import("./ExhibitorList/DropDownFilter");
//const AlphaNumericFilter = () => import("./ExhibitorList/AlphaNumericFilter");
import paginate from "vuejs-paginate";
export default {
  name: "exhibitorlist",
  components: { ExhibitorList, DropDownFilter, AlphaNumericFilter, paginate },
  computed: {
    pageCount: function () {
      return this.$store.state.exhibitorlistInitial.pages;
    },
    forcePage: function () {
      return this.$store.state.exhibitorlistInitial.selectedPage;
    }
  },
  mounted() {
    const url = window.location.href;
    const domain = url.split('/')[2];
    if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    }
    else if (domain === "https://www.egyptminingforum.com/") {
      this.eventname = "emf";
    }
    else if (domain === "worldutilitiescongress.com/") {
      this.eventname = "wuc";
    }
    else {
      this.eventname = "japan";
    }
  },
  methods: {
    clickCallback: function (pageNum) {
      this.$store.dispatch("activePaging", pageNum);
      this.$store.dispatch("exhibitorPaginatedList", pageNum);
    },
    initPagination: function () {
      this.$refs.pagination.selected = 1;
    }
  }
};
</script>
<style>
.pagination {
  display: inline-block;
  padding-left: 0;
}

.pagination>li {
  display: inline;
}

.pagination>.disabled>span,
.pagination>.disabled>span:hover,
.pagination>.disabled>span:focus,
.pagination>.disabled>a,
.pagination>.disabled>a:hover,
.pagination>.disabled>a:focus {
  color: #c09a5d;
  cursor: not-allowed;
  background-color: #fff;
  border-color: #ddd;
}

.pagination>li>a,
.pagination>li>span {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #c09a5d;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  outline: none;
}

.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
  z-index: 2;
  color: #fff;
  cursor: default;
  background-color: #000000;
  border-color: #000000;
}
</style>
